import { RiskRanges } from "../ranges";
import { Risk } from "../units";

function rangesFor({ age }: { age: number }): RiskRanges<"mmol/mol"> {
  if (age >= 50) {
    return new RiskRanges("mmol/mol", [
      { from: 48, to: 52, risk: Risk.HighRisk, label: "diabetes" },
      { from: 43, to: 48, risk: Risk.Risk, label: "pre-diabetes" },
      { from: 39, to: 43, risk: Risk.Normal, label: "normal" },
      { from: 28, to: 39, risk: Risk.Optimal, label: "optimal" },
      { from: 20, to: 28, risk: Risk.HighRisk, label: "low" },
    ]);
  }

  return new RiskRanges("mmol/mol", [
    { from: 48, to: 52, risk: Risk.HighRisk, label: "diabetes" },
    { from: 42, to: 48, risk: Risk.Risk, label: "pre-diabetes" },
    { from: 39, to: 42, risk: Risk.Normal, label: "normal" },
    { from: 28, to: 39, risk: Risk.Optimal, label: "optimal" },
    { from: 20, to: 28, risk: Risk.HighRisk, label: "low" },
  ]);
}

export const HbA1c = {
  rangesFor,
};
